/**
 * Created by r4zi4l on 05.04.2024
 */

Reward.register("piggyBank", {
    flyingAnimation: Reward.NO_ANIMATION,

    parse: function (value, options) {
        const mission = cleverapps.missionManager.findRunningMission(Mission.TYPE_PIGGY_BANK);
        if (mission && !mission.logic.isFull()) {
            return [new Reward("piggyBank", Math.min(value, mission.logic.getMaxAmount() - mission.result), options)];
        }
        return [];
    },

    receive: function (value) {
        const mission = cleverapps.missionManager.findRunningMission(Mission.TYPE_PIGGY_BANK);
        if (mission) {
            mission.logic.add(value);
        }

        return function () {};
    }
});
